<body>
  <div class="center-container">
    <div class="popup" *ngIf="showPopup">

      <img class="logo" src="assets/images/logo.png" alt="Buepp">

      <div *ngIf="isLoading" class="loader-container">
        <div class="loader"></div>
      </div>

      <div *ngIf="!isLoading && !result">
        <div class="slider-container">
          <mat-tab-group [(selectedIndex)]="selectedIndex" animationDuration="1000" disableRipple>
            <mat-tab >
              <ng-template matTabContent>
                <div class="slide-content">
                  <p>¡Pagá más fácil con Buepp!</p>
                  <h5>Escaneá el código QR usando la app.</h5>
                  <ng-container *ngIf="qrCodeImage">
                    <img class="imagenSlide qr" [src]="qrCodeImage" alt="Buepp">
                  </ng-container>
                  
                </div>
              </ng-template>
            </mat-tab>
          
            <mat-tab>
              <ng-template matTabContent>
                <div class="slide-content">
                  <p>Elegí con que cuenta vas a pagar</p>
                  <h5>Seleccioná dentro de la app la opción de dinero en cuenta</h5>
                  <img class="imagenSlide" src="../assets/images/selectAccount.png" alt="Buepp">
                </div>
            </ng-template>
            </mat-tab>
          
            <mat-tab >
              <ng-template matTabContent>
                <div class="slide-content">
                  <p>Completando el pago</p>
                  <h5>Puede tardar unos minutos en reflejarse</h5>
                  <img class="imagenSlide" src="../assets/images/processing.png" alt="Buepp">
                </div>
              </ng-template>
            </mat-tab>
          </mat-tab-group>

          <div class="pagination-dots pagination">
            <button
              *ngFor="let dot of dots; let i = index"
              [class.active]="selectedIndex >= i" 
              [disabled]="selectedIndex < i">  
            </button>
          </div>

        </div>
        <div class="datos">
          <p>{{datosPago.datosPago.tramite}}</p>
          <p>N° de boleta: {{datosPago.datosPago.numeroBoleta}}</p>
          <p>Fecha de vencimiento: {{formatDate(datosPago.datosPago.fechaVencimiento)}}</p>
        </div>
        <p class="importe">${{datosPago.datosPago.importe}}</p>
        
        <div class="info">
          <p>No cierres la ventana hasta finalizar el pago.</p>
        </div>
      </div>
      <div *ngIf="result">
        <ng-container *ngIf="stateOfTheIntention === 'FINALIZADA_OK'">
          <p>¡Listo!</p>
          <h5>Completaste tu pago.</h5>
          <img class="imagenSlide" src="../assets/images/success.png" alt="Buepp">
        </ng-container>
        <ng-container *ngIf="stateOfTheIntention === 'FINALIZADA_OK_PAGO_NO_INFORMADO'">
          <p>Completaste tu pago</p>
          <h5>Por el momento el pago no se verá reflejado en la web del GCBA de inmediato. Seguirá figurando como pendiente, no lo repitas.</h5>
          <img class="imagenSlide" src="../assets/images/success.png" alt="Buepp">
        </ng-container>
        <ng-container *ngIf="stateOfTheIntention === 'FINALIZADA_ERROR' || stateOfTheIntention === 'VENCIDA'">
          <p>Tuvimos un problema</p>
          <h5 *ngIf="errorLoading">No podés pagar con Buepp en este momento. Por favor, volvé a intentar en unos minutos.</h5>
          <h5 *ngIf="!errorLoading">Tu pago no se pudo completar. Por favor, volvé a intentar.</h5>
          <img class="imagenSlide" src="../assets/images/error.png" alt="Buepp">
        </ng-container>
        <ng-container *ngIf="stateOfTheIntention === 'FINALIZADA_CON_ERROR_YA_PAGADA'">
          <p>Esta boleta ya se encuentra pagada</p>
          <h5>Identificamos un pago anterior con este N° de boleta</h5>
          <img class="imagenSlide" src="../assets/images/error.png" alt="Buepp">
        </ng-container>
        <div class="redirect">
          <a class="urlPage"
            (click)="closeIframeAndRedirect(
              stateOfTheIntention === 'FINALIZADA_CON_ERROR_YA_PAGADA' ? errorPagadaUrl :
              (stateOfTheIntention === 'FINALIZADA_ERROR' || stateOfTheIntention === 'VENCIDA' ? errorUrl : callBackUrl))">
              Ir al sitio de Ciudad de Buenos Aires</a>
          <p>Vamos a redirigirte al sitio de Ciudad de Buenos Aires en {{counter}} segundos.</p>
        </div>
      </div>
    </div>
  </div>
</body>


